import { SystemModel } from '@domain/models';

export type SystemState = SystemModel;

export const initialSystemState: SystemState = {
  enums: {
    dataSourceType: [],
    filterActions: [],
    taskType: [],
    chatChannelType: [],
    taskShift: [],
    taskConfigTrigger: [],
    sectorType: [],
    subTaskFormType: [],
    checklistStatus: [],
    taskStatus: [],
    uploadContextType: [],
    userRole: [],
    stockConfig: [],
    inputFiledType: [],
    shiftType: [],
    notificationType: [],
    notificationTrigger: [],
    notificationAlertType: [],
    auditLogModule: [],
    auditLogType: [],
    auditLogFilterConfiguration: [],
    auditLogConfigEventEnum: [],
    auditLogFilterUser: [],
    auditLogUserEventEnum: [],
    systemDataSourceType: [],
  },
  inputTypeMapping: [],
  menuList: [],
  menuListLoaded: false,
};
